<mat-dialog-content>
    <div class="container">
        <div class="flex-container">
            <mat-radio-group aria-label="Add to Train">
                <mat-radio-button value="1" [checked]="selectedOption === 1"
                    (change)="radioButtonChanged(1)">Carriage</mat-radio-button>
                <mat-radio-button class="my-radio-button" [checked]="selectedOption === 2" value="2"
                    (change)="radioButtonChanged(2)">Locomotive</mat-radio-button>
            </mat-radio-group>
            <span class="spacer"></span>
            <form [formGroup]="variantForm">
                <mat-form-field appearance="outline" class="custom-field-size">
                    <mat-label>{{ selectedOption === 1 ? 'Name of carriage' : 'Name of locomotive' }}</mat-label>
                    <input matInput autoComplete="off" formControlName="name">
                    <mat-error
                        *ngIf="variantForm.controls.name.invalid && (variantForm.controls.name.dirty || variantForm.controls.name.touched)">
                        <span *ngIf="variantForm.controls.name.errors?.nameAlreadyTaken">The provided name is already in
                            use.</span>
                        <span *ngIf="variantForm.controls.name.errors?.required">Name is required!</span>
                        <span *ngIf="variantForm.controls.name.errors?.maxlength">Maximum length of 100 characters
                            exeeded!</span>
                    </mat-error>
                </mat-form-field>
            </form>
        </div>
        <div *ngIf="selectedOption === 1" class="selection-container">
            <div class="select-group">
                <mat-form-field class="custom-field-size">
                    <mat-label>Select carriage</mat-label>
                    <mat-select [(ngModel)]="selectedWagon" (selectionChange)="loadVariants()">
                        <mat-option class="select-without-checkbox" *ngFor="let wagon of data.wagonList"
                            [value]="wagon">{{wagon.name}}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="custom-field-size">
                    <mat-label>Select variant</mat-label>
                    <mat-select [(ngModel)]="selectedVariant" [disabled]="!selectedWagon"
                        (selectionChange)="variantSelectionChanged()">
                        <mat-option class="select-without-checkbox" *ngFor="let variant of variantList"
                            [value]="variant">{{variant.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-icon *ngIf="selectedOption === 1 && selectedVariant" (click)=" rotate($event)"
                    title="rotate">rotate_left</mat-icon>
            </div>
            <div *ngIf="selectedVariant" class="image-container">
                <img [ngClass]="rotated ? 'rotate-image' : ''" title="image"
                    [src]="variantImageSource ? variantImageSource : ''" />
            </div>
            <h3 class="warning" *ngIf="isWarningToShow"><mat-icon
                    title="This may lead to incorrect results.">warning</mat-icon>
                {{warningMessage}}</h3>
        </div>
        <div *ngIf="selectedOption === 2" class="selection-container">
            <div class="image-container">
                <img title="image" [src]="locomotiveImageSource" />
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button class="color" mat-button (click)="cancel()">Cancel</button>
    <span class="spacer"></span>
    <button [disabled]="!variantForm.valid" class="color" mat-button (click)="save()">Save</button>
</mat-dialog-actions>